import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";
import { nullable } from "diagnostics-lib/io";
export const useSelectedDiagramAnnotation = createGlobalState({
  storage: "local",
  key: "SelectedDiagramAnnotation",
  scoped: true,
  defaultValue: null,
  type: nullable(io.number),
});
